import { render, staticRenderFns } from "./QuickChatSendResult.vue?vue&type=template&id=2c2a8052&scoped=true&"
import script from "./QuickChatSendResult.vue?vue&type=script&lang=ts&"
export * from "./QuickChatSendResult.vue?vue&type=script&lang=ts&"
import style0 from "./QuickChatSendResult.vue?vue&type=style&index=0&id=2c2a8052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2a8052",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
